import { isEqual, omitBy } from "lodash-es";
import { type PlanningProposalsFilter } from "~/api/generated/model";
import { type ProposalSearch } from "~/routes/(restricted)/byggeradar/-schemas/proposal-search";

/**
 * Pick specific search items for filters (e.g. `page` excluded)
 */
export const searchToApi = (search: ProposalSearch): PlanningProposalsFilter =>
  omitBy(
    {
      ...search,
      page: undefined,
    },
    (val, key) => key === "page" || typeof val === "undefined",
  );

/**
 * Check if search & saved filter has differences
 */
export const isDifferent = (
  search: ProposalSearch = {},
  filters: PlanningProposalsFilter,
) =>
  !isEqual(
    omitBy(searchToApi(search), (val) => typeof val === "undefined"),
    filters,
  );
